export enum FeatureFlags {
  UI_REFRESH = "designControlsUiRefresh",
  COMPARE_VIEW = "designControlsComparisonView",
  TRACEABILITY_LIMIT = "designControlsTraceabilityLimit",
  API_V2 = "design-controls-fargate-api",
}
